module.exports = __webpack_public_path__ + "media/choujiang.49fad1a8.mp3";